module.exports = __webpack_public_path__ + "static/media/intro.0018fc63.mp4";